export const getTrendColor = (trend, theme) => {
  const colors = theme && theme.colors ? theme.colors : { feedback: { success: '#28a745', error: '#dc3545', info: '#17a2b8' } };
  switch (trend) {
    case 'up': return colors.feedback.success;
    case 'down': return colors.feedback.error;
    case 'neutral':
    default: return colors.feedback.info;
  }
};

export const getTrendIcon = (trend) => {
  switch (trend) {
    case 'up': return 'arrow-up';
    case 'down': return 'arrow-down';
    case 'neutral':
    default: return 'minus';
  }
};

export const formatValue = (value, prefix = '', suffix = '') => {
  if (value === null || value === undefined) return '-';
  return `${prefix}${value}${suffix}`;
};



// WEBPACK FOOTER //
// ./src/design-system/molecules/CardValue/utils/cardValueHelpers.js